export function httpsUrl(value: string | null): string | null {
  try {
    const url = new URL(value || "");
    return url.protocol === "https:" ? url.href : null;
  } catch {
    return null;
  }
}

export function getJourneyVideoSource(
  value: string | null,
): { src: string; embed: boolean } | null {
  const safe = httpsUrl(value);
  if (!safe) return null;
  const url = new URL(safe);
  const host = url.hostname.replace(/^www\./, "");
  if (
    host === "youtu.be" ||
    host === "youtube.com" ||
    host === "m.youtube.com"
  ) {
    const id =
      host === "youtu.be"
        ? url.pathname.slice(1)
        : url.searchParams.get("v") || url.pathname.split("/")[2];
    if (id && /^[\w-]+$/.test(id))
      return { src: `https://www.youtube.com/embed/${id}`, embed: true };
  }
  if (host === "vimeo.com" || host === "player.vimeo.com") {
    const parts = url.pathname.split("/").filter(Boolean);
    let id = parts.at(-1);
    let hash = url.searchParams.get("h");
    // Unlisted share links put the privacy hash after the video ID. Embed
    // links carry the same hash as ?h=; omitting it makes the video unavailable.
    if (host === "vimeo.com" && parts.length === 2 && /^\d+$/.test(parts[0])) {
      id = parts[0];
      hash = parts[1];
    }
    if (hash !== null && !/^[a-zA-Z0-9]+$/.test(hash)) return null;
    if (id && /^\d+$/.test(id))
      return {
        src: `https://player.vimeo.com/video/${id}${hash ? `?h=${hash}` : ""}`,
        embed: true,
      };
  }
  if (host === "iframe.mediadelivery.net") return { src: safe, embed: true };
  if (/\.(mp4|m4v|webm|mov|m3u8)$/i.test(url.pathname))
    return { src: safe, embed: false };
  return null;
}
